import { render, staticRenderFns } from "./CancelSubmitForm8.vue?vue&type=template&id=12be841a&scoped=true"
import script from "./CancelSubmitForm8.vue?vue&type=script&lang=ts"
export * from "./CancelSubmitForm8.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be841a",
  null
  
)

export default component.exports